import { cn } from '@/lib/utils';
import type { PropsWithChildren } from 'react';

export default function AuthLayout({ children, className }: PropsWithChildren<{ className?: string }>) {
	return (
		<main
			className={cn(
				'auth-bg relative flex min-h-full w-full flex-col items-center justify-center overflow-hidden px-5',
				'pb-[max(1.5rem,env(safe-area-inset-bottom))] pt-[max(1.5rem,env(safe-area-inset-top))]',
				className,
			)}
		>
			<div className='pointer-events-none absolute inset-0 auth-bg-glow' aria-hidden />
			<div className='relative z-10 flex w-full max-w-sm flex-col items-center gap-8'>{children}</div>
		</main>
	);
}
